import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ColorEnum } from 'shared/design-system/data-access/theme';
import { RemSize } from 'shared/design-system/data-access/layout';

type TypographyVariant = 'medium-text' | 'detail-text' | 'h3';
type TextOverflow = 'wrap' | 'ellipsis' | 'pre-line';

@Component({
    selector: 'it-text-new',
    imports: [NgTemplateOutlet, NgStyle],
    templateUrl: './text-new.component.html',
    styleUrls: ['./text-new.component.scss'],
})
export class TextNewComponent {
    @Input() variant?: TypographyVariant;
    @Input() underline?: boolean;
    @Input() color?: ColorEnum | string;
    @Input() fontSize?: RemSize;
    @Input() textAlign?: 'center' | 'left' | 'right';
    @Input() overflow?: TextOverflow;

    ColorEnum = ColorEnum;

    get style() {
        const baseStyle = {
            textDecoration: this.underline ? 'underline' : undefined,
            color: this.underline ? ColorEnum.BLUE_500 : this.color,
            textAlign: this.textAlign ?? undefined,
            fontSize: this.fontSize ?? undefined,
        };

        if (this.overflow === 'ellipsis') {
            return {
                ...baseStyle,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            };
        }

        if (this.overflow === 'wrap') {
            return {
                ...baseStyle,
                whiteSpace: 'normal',
                wordWrap: 'break-word',
            };
        }

        if (this.overflow === 'pre-line') {
            return {
                ...baseStyle,
                whiteSpace: 'pre-line',
                wordWrap: 'break-word',
            };
        }

        return baseStyle;
    }
}
